﻿/**
 * This function is written in a javascript file because TypeScript is compiling the "import" keyword into something else.
 * Webpack knows and understands what import is and is a critical piece in bundling our code for production, so by putting
 * the code into a javascript file, we preserve the import keyword and all functionality.
 */
export default function (path) {
    return import('Modules/' + path + '.vue');
}